module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0030.jpg?v=47cbfbe1";